import { CommunityTalent } from "__generated__/graphql";
import { z } from "zod";

// Step 1: Company Information Schema
export const companyInformationSchema = z.object({
  organization: z.string().min(1, "Organization name is required"),
  roleInOrganization: z.string().min(1, "Your role is required"),
});

// Step 2: Contact Details Schema
export const contactDetailsSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Please enter a valid email address"),
  phone: z.string().min(10, "Please enter a valid phone number"),
});

// Step 3: Community Information Schema
export const communityInformationSchema = z.object({
  typeOfCommunity: z.string().min(1, "Type of community managed is required"),
  communitySize: z.string().min(1, "Community size is required"),
  communityTalent: z.array(z.nativeEnum(CommunityTalent)).min(1, {
    message: "Please select at least one community talent",
  }),
  majorChallenges: z.string().min(1, "Major challenges is required"),
  digitalToolsUsed: z.string().optional(),
});

export enum PreferredDemoTime {
  MORNING = "morning",
  AFTERNOON = "afternoon",
  EVENING = "evening",
}

// Step 4: Demo Preference Schema
export const demoPreferenceSchema = z.object({
  preferredDate: z.date({
    required_error: "Please select your preferred demo date",
    invalid_type_error: "Please enter a valid date",
  }).min(new Date(), "Demo date must be in the future"),
  preferredTime: z.nativeEnum(PreferredDemoTime, {
    errorMap: () => ({ message: "Please select your preferred demo time" }),
  }),
});

export const communityDemoRequestSchema = companyInformationSchema
  .merge(contactDetailsSchema)
  .merge(communityInformationSchema)
  .merge(demoPreferenceSchema);

export type CompanyInformationFormData = z.infer<
  typeof companyInformationSchema
>;
export type ContactDetailsFormData = z.infer<typeof contactDetailsSchema>;
export type CommunityInformationFormData = z.infer<typeof communityInformationSchema>;
export type DemoPreferenceFormData = z.infer<typeof demoPreferenceSchema>;
export type CommunityDemoRequestFormData = z.infer<typeof communityDemoRequestSchema>;
